import { createSlice } from '@reduxjs/toolkit';
import { reHydrateStore } from '../utils/local-storage';

const initialState = {
  isEmbedded: false,
  data: {
    appToken: null,
  },
};

const embeddedSlice = createSlice({
  name: 'embedded',
  initialState: reHydrateStore('embedded') || initialState,
  reducers: {
    setEmbedded: (state, { payload }) => payload,
    loadEmbedded: (state, { payload }) => ({
      ...state,
      ...payload,
    }),
    setIsEmbedded: (state, { payload }) => ({
      ...state,
      isEmbedded: payload,
    }),
    setData: (state, { payload }) => ({
      ...state,
      data: payload,
    }),
    restore: () => initialState,
  },
});

export const { setEmbedded, loadEmbedded, setIsEmbedded, setData, restore } =
  embeddedSlice.actions;

export default embeddedSlice.reducer;
